import * as React from "react";

import { translate } from "@/modules/shared/IntlProviderWrapper";
import ErrorComponent from "@/modules/shared/ui/ErrorComponent";

class KioskUndefined extends React.Component {
    render() {
        return (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <ErrorComponent type="error" msg={translate("common.kiosk_screen_error", "Kiosk screen error")} />
            </div>
        );
    }
}

export default KioskUndefined;
